import { IAttachmentsUploadConfigVm } from "./interfaces";

export enum AttachmentRelatesTo {
    Undefined = 0,
    DcfRequest = 1
}

export enum FileAttachmentsTableMode {
    ModifyList,
    ListOnly
}

export const DefaultFileAttachmentsUploaderSettings: IAttachmentsUploadConfigVm = {
    attachmentRelatesTo: AttachmentRelatesTo.Undefined,
    maxFileCount: 5,
    maxFileSize: 5242880, // 5 MB per file
    allowedFileTypeExtensions: {
        "application/pdf": [".pdf"],
        "text/plain": [".txt"],
        "application/msword": [".doc"],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ["docx"],
        "application/vnd.ms-outlook": [".msg"],
        "message/rfc822": [".eml"],
        "image/jpg": [".jpg", ".jpeg"],
        "image/png": [".png"],
        "image/gif": [".gif"],
        "application/vnd.ms-excel": [".xls"],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"]
    }
};
